import { DecimalPipe } from '@angular/common';
import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectComponent } from '@ng-select/ng-select';
import { CreateProductComponent } from 'app/dialogs/create-product/create-product.component';
import { TransactionCreateDilaogComponent } from 'app/dialogs/transaction-create-dilaog/transaction-create-dilaog.component';
import { CreateTransaction } from 'app/dtos/Transaction/createTransaction';
import { CreateTransactionProduct } from 'app/dtos/Transaction/createTransactionProduct';
import { _isId } from 'app/services/auth.service';
import { ProductService } from 'app/services/models/product.service';
import { ProjectService } from 'app/services/models/project.service';
import { TransactionService } from 'app/services/models/transaction.service';
import { Turkish } from 'flatpickr/dist/l10n/tr';
import { link } from 'fs';
import moment from 'moment';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-create-fixtures',
  templateUrl: './create-fixtures.component.html',
  styleUrls: ['./create-fixtures.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CreateFixturesComponent implements OnInit {
  @BlockUI('section-block') blockUI: NgBlockUI;
  @ViewChild('productSelect') productSelect: NgSelectComponent;

  public contentHeader;
  transactionList: any[] = [];
  totalAmount: number | null = null;
  selectedProjectId = null;
  products: any[] = [];
  project: any[] = [];

  isPrivate: boolean = false;
  isMobile: boolean;

  constructor(
    private productService: ProductService,
    private modalService: NgbModal,
    private projectService: ProjectService,
    private decimalPipe: DecimalPipe,
    private transactionService: TransactionService,
    private toastrService: ToastrService,
    private router: Router
  ) { }

  async ngOnInit() {
    this.contentHeader = {
      headerTitle: 'Demirbaş',
      actionButton: true,
      breadcrumb: {
        type: '',
        links: [
          {
            name: 'Demirbaş Listesi',
            isLink: true,
            link: '/fixtures'
          },
          {
            name: 'Demirbaş Ekleme',
            isLink: false,
          },
        ]
      }
    };
    await this.getAllProducts();
    await this.getAllProjects('');
  }

  onProductChange(selectedProductId: number) {
    console.log("Seçilen ürün ID : ", selectedProductId);
    if (selectedProductId) {
      this.transactionShow(selectedProductId);
    } else {
      console.log("Ürün seçilmedi veya seçim iptal edildi.");
    }
  }

  transactionShow(product) {
    const modal = this.modalService.open(TransactionCreateDilaogComponent, {
      size: 'ml',
      centered: true,
      windowClass: 'modal modal-success'
    });
    modal.componentInstance.data = {
      message: `${product.name}`,
      product: product,
      discountRate: 0,
      transactionId: null,
      kindId: 5
    };
    modal.result.then((result) => {
      if (result) {
        this.transactionList.push(result);
        console.log("İşlem Listesi: ", this.transactionList);
        this.calculateTotalAmount();
        this.calculateVatTotals(this.transactionList);
        this.calculatePurchaseTaxTotals(this.transactionList);
        this.calculateNetVatDifference(this.transactionList);
        this.calculateNetDifference(this.transactionList);
        this.productSelect.writeValue(null);
      }
    }, (reason) => {
      console.log('Modal kapatıldı:', reason);
    });
  }


  formatNumber(value: number): string {
    return this.decimalPipe.transform(value, '1.2-2') || '0.00';
  }

  total: Number = 0;

  calculateNetDifference(transactions) {
    const salePriceTotal = transactions.reduce((total, transaction) => {
      // Satış fiyatı hesapla: (salePrice * count) + (KDV dahil)
      const totalSalePrice = (transaction.total) || 0;
      return total + totalSalePrice;
    }, 0);

    // Toplam alış fiyatını hesapla
    const purchasePriceTotal = transactions.reduce((total, transaction) => {
      const { product, count } = transaction;
      const { purchasePrice, purchaseTax } = product;

      // Alış fiyatına KDV ekle
      const totalPurchasePriceWithTax = (purchasePrice + ((purchasePrice * purchaseTax) / 100)) * count || 0;

      return total + totalPurchasePriceWithTax;
    }, 0);

    // Toplam satış fiyatı ile toplam alış fiyatı arasındaki farkı hesapla
    const netDifference = salePriceTotal - purchasePriceTotal;

    // Net farkı döndür
    this.total = netDifference;
  }

  vatDifference: number = 0;
  calculateNetVatDifference(transactions) {
    // Calculate total sales VAT
    const vatTotals = this.calculateVatTotals(transactions);
    const totalSalesVat = vatTotals.reduce((total, item) => total + item.totalVat, 0);
    console.log(totalSalesVat);
    // Calculate total purchase VAT
    const purchaseTaxTotals = this.calculatePurchaseTaxTotals(transactions);
    const totalPurchaseVat = purchaseTaxTotals.reduce((total, item) => total + item.totalPurchaseTax, 0);
    console.log(totalPurchaseVat);
    // Calculate the difference
    const netVatDifference = totalSalesVat - totalPurchaseVat;
    // Log the results for debugging
    console.log(`Total Sales VAT: ${totalSalesVat}`);
    console.log(`Total Purchase VAT: ${totalPurchaseVat}`);
    console.log(`Net VAT Difference: ${netVatDifference}`);
    this.vatDifference = netVatDifference;
    return netVatDifference;
  }

  transactionVatTotal: any[];
  calculateVatTotals(transactions) {
    const vatTotalsMap: { [saleTaxId: number]: { saleTax: number, totalVat: number } } = {};

    transactions.forEach(transaction => {
      const { saleTaxId, salePrice, count, saleTax } = transaction;

      // Calculate the total amount before VAT
      const totalBeforeVat = salePrice * count;

      // Calculate VAT for this transaction
      const vat = (totalBeforeVat * saleTax) / 100;
      if (!vatTotalsMap[saleTaxId]) {
        vatTotalsMap[saleTaxId] = { saleTax, totalVat: 0 };
      }
      vatTotalsMap[saleTaxId].totalVat += vat;
    });
    // Convert vatTotalsMap to an array
    this.transactionVatTotal = Object.keys(vatTotalsMap).map(saleTaxId => ({
      saleTaxId: +saleTaxId,
      saleTax: vatTotalsMap[+saleTaxId].saleTax,
      totalVat: vatTotalsMap[+saleTaxId].totalVat
    }));
    console.log(this.transactionVatTotal);
    return this.transactionVatTotal;
  }

  transactionPurchaseTaxTotal: any[];
  calculatePurchaseTaxTotals(transactions) {
    const purchaseTaxTotalsMap: { [purchaseTaxId: number]: { purchaseTax: number, totalPurchaseTax: number } } = {};

    transactions.forEach(transaction => {
      const { product, count } = transaction;
      const { purchaseTaxId, purchasePrice, purchaseTax } = product;

      // Calculate the total amount before purchase tax
      const totalBeforeTax = purchasePrice * count;

      // Calculate purchase tax for this transaction
      const purchaseTaxAmount = (totalBeforeTax * purchaseTax) / 100;

      if (!purchaseTaxTotalsMap[purchaseTaxId]) {
        purchaseTaxTotalsMap[purchaseTaxId] = { purchaseTax, totalPurchaseTax: 0 };
      }

      purchaseTaxTotalsMap[purchaseTaxId].totalPurchaseTax += purchaseTaxAmount;
    });

    // Convert purchaseTaxTotalsMap to an array
    this.transactionPurchaseTaxTotal = Object.keys(purchaseTaxTotalsMap).map(purchaseTaxId => ({
      purchaseTaxId: +purchaseTaxId,
      purchaseTax: purchaseTaxTotalsMap[+purchaseTaxId].purchaseTax,
      totalPurchaseTax: purchaseTaxTotalsMap[+purchaseTaxId].totalPurchaseTax
    }));

    console.log(this.transactionPurchaseTaxTotal);
    return this.transactionPurchaseTaxTotal;
  }

  calculateTotalAmount() {
    this.totalAmount = this.transactionList.reduce((acc, transaction) => acc + (transaction.total || 0), 0);
  }

  showCreateProductDialog() {
    this.modalService.open(CreateProductComponent, {
      size: 'lg',
      windowClass: 'modal modal-success'
    });
    this.productService.event$.subscribe(async result => {
      await this.getAllProducts();
    })
  }

  onProjectChange(event) {
    this.selectedProjectId = event.id;
    console.log(this.selectedProjectId)
  }


  isDiscount: boolean = false;
  isPrivateDiscountToogle() {
    this.isDiscount = !this.isDiscount;
  }

  isPrivateToogle() {
    this.isPrivate = !this.isPrivate;
  }

  async getAllProjects(search: string) {
    this.blockUI.start("Projeler yükleniyor...")
    const data = await this.projectService.getAllProject(0, 100, search);
    this.project = data.projects;
    this.blockUI.stop();
  }

  async getAllProducts() {
    const data = await this.productService.getAllProducts(0, 1000, '');
    console.log(data);
    this.products = data.products.filter(p => p.id !== 1);
  }


  sumCount(): number {
    return this.transactionList.reduce((total, transaction) => {
      // Ensure 'count' exists and is a number
      return total + (transaction.count || 0);
    }, 0);
  }

  sumGross(): number {
    return this.transactionList.reduce((total, transaction) => {
      // Ensure 'count' exists and is a number
      return total + (transaction.salePrice * transaction.count || 0);
    }, 0);
  }

  sumDiscount(): number {
    return this.transactionList.reduce((total, transaction) => {
      // Ensure 'count' exists and is a number
      return total + (((transaction.salePrice * transaction.count) * transaction.discountRate) / 100 || 0);
    }, 0);
  }

  sumBuyingCount(): number {
    return this.transactionList.reduce((total, transaction) => {
      // Ensure 'count' exists and is a number
      return total + ((transaction.product.purchasePrice * transaction.count) || 0);
    }, 0);
  }

  sumExcludingVAT(): number {
    // Toplam net tutar ile ürünlerin alış fiyatlarının toplamını çıkarmak
    const totalNet = this.sumNetTotal(); // Toplam net tutarı al
    const totalPurchasePrice = this.transactionList.reduce((total, transaction) => {
      // Alış fiyatı ile miktarın çarpımını topla
      return total + (transaction.product.purchasePrice * transaction.count);
    }, 0);

    // Toplam net tutardan alış fiyatı toplamını çıkart
    return totalNet - totalPurchasePrice;
  }

  sumNetTotal(): number {
    return this.transactionList.reduce((total, transaction) => {
      const totalPrice = transaction.salePrice * transaction.count;
      if (transaction.discountRate === 0) {
        // No discount applied, just add the total price
        return total + totalPrice;
      } else {
        // Discount applied, calculate the amount after discount
        const discount = (totalPrice * transaction.discountRate) / 100;
        return total + (totalPrice - discount);
      }
    }, 0);
  }

  date = new Date();
  date2 = moment().add(15, 'days').toDate();

  public dateTimeStartOptions: FlatpickrOptions = {
    altInput: true,
    enableTime: true,
    dateFormat: 'd.m.Y H:i',
    altFormat: 'd.m.Y H:i',
    locale: Turkish,
    defaultDate: this.date
  };

  public dateTimeEndOptions: FlatpickrOptions = {
    altInput: true,
    enableTime: true,
    dateFormat: 'd.m.Y H:i',
    altFormat: 'd.m.Y H:i',
    locale: Turkish,
    defaultDate: this.date2
  };

  async createOffer() {
    this.blockUI.start("Demirbaş oluşturuluyor...");
    const createTransaction = new CreateTransaction();
    createTransaction.startDate = new Date(this.dateTimeStartOptions.defaultDate);
    createTransaction.validityDate = new Date(this.dateTimeEndOptions.defaultDate);
    createTransaction.transactionPrivateNode = null;
    createTransaction.companyId = 3; // company id burada olmalı
    createTransaction.kindId = 5; // kindId'nin nereden geldiğini belirleyin
    createTransaction.userId = _isId; // userId'nin nereden geldiğini belirleyin
    createTransaction.personId = null;
    createTransaction.projectId = null;
    createTransaction.docNo = null;
    createTransaction.requestTaskId = null;
    createTransaction.createTransactionProducts = this.transactionList.map(transaction => {
      const transactionProduct = new CreateTransactionProduct();
      transactionProduct.productId = transaction.product.id;
      transactionProduct.warehouseId = transaction.selectedWarehouseId;
      transactionProduct.productCount = transaction.count;
      transactionProduct.productPrice = transaction.salePrice;
      transactionProduct.taxId = transaction.saleTaxId;
      transactionProduct.discountRate = transaction.discountRate;
      transactionProduct.currencyId = transaction.currencyId;
      transactionProduct.description = transaction.description;
      transactionProduct.seriNos = transaction.seriNos;
      transactionProduct.saleSerialNos = transaction.saleSerialNos
      return transactionProduct;
    });
    console.log(createTransaction);

    const response = await this.transactionService.createOffer(createTransaction);
    if (response.status == true) {
      this.blockUI.stop();
      this.toastrService.success("Demirbaş başarılı bir şekilde eklendi.");
      this.router.navigate(['/admin/fixtures']);
    } else {
      this.blockUI.stop();
      this.toastrService.error("Demirbaş eklenirken bir problem oluştu.");
    }

  }
}
